module.exports = __webpack_public_path__ + "static/media/lead-bg.ddbf4101.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/lead-bg.webp
// module id = 1221
// module chunks = 1